import { SidebarItem } from './sidebar.types';

export const getActiveItem = (items: SidebarItem[], pathname: string) => {
  const activeItem = items.find((item) => {
    if (!item.route) return false;
    const isRoot = item.route === '/';
    const baseRoute = item.route.includes('?') ? item.route.split('?')[0] : item.route;
    if (isRoot) return pathname === baseRoute;
    return pathname === baseRoute || pathname.startsWith(baseRoute);
  });
  return activeItem;
};
